import React, { ReactElement } from 'react';
import { Typography } from '@material-ui/core';
// import useStyles from './styles';
import GridLayout from '../../../../components/molecules/grid_layout';
import * as DateUtils from 'utils/dates';
import { readableRegistrationState, readableRegistrationStatus } from 'config';
import _ from 'lodash';

interface IAdministration {
  registration_comments: string;
  registration_date: Date;
  commencement_date: Date;
  change_date: Date;
  modified_at: string;
  created_at: string;
  status: string;
  status_id: number;
  state: string;
  changed_at: string;
  transmitted: string;
}
interface IProps {
  data: Array<IAdministration>;
}

export default function AdministrationInfo(props: IProps): ReactElement {
  // console.log('Render AdministrationInfo');
  let administration_info: IAdministration = props.data[0];
  return (
    <div>
      <Typography variant="h5">REGISTRATION STATE INFORMATION</Typography>
      <GridLayout
        elements={[
          {
            element: renderBold('Status'),
            size: 4,
            id: 'status_label',
          },
          {
            element: renderSpan(
              readableRegistrationStatus[administration_info.status_id] ||
                'Unknown'
            ),
            size: 8,
            id: 'status_value',
          },

          {
            element: renderBold('State'),
            size: 4,
            id: 'state_label',
          },
          {
            element: renderSpan(
              _.get(
                readableRegistrationState,
                administration_info.state,
                'Unknown'
              )
            ),
            size: 8,
            id: 'state_value',
          },

          {
            element: renderBold('Transmitted'),
            size: 4,
            id: 'transmitted_label',
          },
          {
            element: renderSpan(administration_info.transmitted),
            size: 8,
            id: 'transmitted_value',
          },

          {
            element: renderBold('Updated'),
            size: 4,
            id: 'updated_label',
          },
          {
            element: renderSpan(
              DateUtils.formatDateTime(administration_info.changed_at) ||
                'Unknown'
            ),
            size: 8,
            id: 'updated_value',
          },

          {
            element: renderBold('Modified'),
            size: 4,
            id: 'modified_label',
          },
          {
            element: renderSpan(
              DateUtils.formatDateTime(administration_info.modified_at) ||
                'Unknown'
            ),
            size: 8,
            id: 'modified_value',
          },

          {
            element: renderBold('Created'),
            size: 4,
            id: 'created_label',
          },
          {
            element: renderSpan(
              DateUtils.formatDateTime(administration_info.created_at) ||
                'Unknown'
            ),
            size: 8,
            id: 'created_value',
          },
        ]}
      />
    </div>
  );
}

const renderBold = (label: string) => {
  return <span style={{ fontWeight: 'bold' }}>{label}</span>;
};

const renderSpan = (label: string) => {
  return <span>{label}</span>;
};
